<script setup lang="ts">
import type { CardGeneric } from '~/types/cards'
import type { ButtonProps } from '~/components/atoms/ButtonV2'
import { ButtonV2 } from '~/components/atoms/ButtonV2'
import { CardInfoList } from '~/components/molecules/CardInfoList'

defineProps<{
  title: string
  subTitle: string
  items: CardGeneric[]
  button: ButtonProps
}>()
</script>

<template>
  <section class="w-full px-6 md:px-10 py-4 md:py-10 bg-foundation-azul2 flex flex-col gap-8 md:gap-10">
    <!-- Header: title, subtitle and CTA -->
    <div class="flex flex-col items-center gap-2 md:gap-8">
      <div class="flex flex-col gap-2 md:gap-4">
        <h2 class="text-center text-neutral-6 text-2xl md:text-3xl font-bold font-mplus leading-7 md:leading-10">
          {{ title }}
        </h2>
        <p class="text-center text-neutral-6 text-base font-normal font-mplus leading-6">
          {{ subTitle }}
        </p>
      </div>

      <ButtonV2
        v-if="button"
        v-bind="button"
        :appearance="button?.appearance ?? 'white'"
        class="hidden md:block w-fit mx-auto bg-neutral-6 text-foundation-azul2 !typo-p2-upper whitespace-nowrap px-6!"
      />
    </div>

    <!-- Items grid: mobile coluna gap-2 | desktop linha enrolável h-52 gap-6 -->
    <div class="flex flex-col gap-2 md:flex-row md:flex-wrap md:gap-6">
      <CardInfoList
        v-for="(item, index) in items"
        :key="index"
        :title="item.title"
        :description="item.description"
        :start-icon="item.icon?.url"
        :contained="false"
        :class-names="{
          root: 'w-full md:flex-1 p-4 bg-foundation-azul1 rounded-3xl flex flex-row md:flex-col justify-start h-auto',
          startIcon: 'md:size-8',
          contentWrapper: 'md:w-full',
          title: 'text-neutral-6 md:text-2xl md:leading-7',
          description: 'text-neutral-6 md:text-base md:leading-6'
        }"
      />
    </div>

    <ButtonV2
      v-if="button"
      v-bind="button"
      :appearance="button?.appearance ?? 'white'"
      class="md:hidden w-fit mx-auto bg-neutral-6 text-foundation-azul2 !typo-p2-upper whitespace-nowrap px-6!"
    />
  </section>
</template>
